import lexisLogo from 'assets/images/intro/LEXIS_The_Platform_RGB_transparent.png';
import { Typography } from '@mui/material';
import { IS_EFP } from 'config';

const isEFP = IS_EFP;

const HeaderLogoMain = ({ reverse, ...others }: { reverse?: boolean }) => {
    return isEFP ? (
        <Typography variant='h4' component='div' sx={{ flexGrow: 1 }}>
            EFP Workflows
        </Typography>
    ) : (
        <img src={lexisLogo} alt='Lexis' width='200' />
    );
};

export default HeaderLogoMain;
